import styled from 'styled-components';

export const MrdContactsCreateDialogStyles = styled.div`
  .contact-form-details {
    width: 50%;
    border-collapse: collapse;
    margin-left: 25px;
    margin-top: 10px;
    margin-right: 25px;

    .contact-form-input-details {
      vertical-align: middle;
      z-index: 1;
      min-width: 125px;
      padding-bottom: 10px;
      padding-left: 5px;

      .MuiCheckbox-root {
        margin-left: -10px;
      }
    }
  }
`;
